<template>
  <router-view/>
</template>


<style>
#app {
font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
*{
  margin: 0;
  padding: 0;
}

</style>
